module.exports = __webpack_public_path__ + "img/btn_spin.2039e3db.png";